module.exports = __webpack_public_path__ + "static/img/whatsapp.84d2d15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/whatsapp.svg
// module id = 3dvL
// module chunks = 1